<script>
import Layout from '@layouts/public.vue'
import { mapGetters, mapActions } from 'vuex'
import baseMixin from '@/mixins/baseMixin'

export default {
  name: 'UnderConstructionView',
  metaInfo() {
    return {
      title: this.$route?.meta?.title,
      meta: [{ name: 'description', content: 'Under Construction page.' }],
    }
  },
  components: {
    Layout,
  },
  mixins: [baseMixin],
  computed: {
    ...mapGetters({
      isUserLoggedIn: 'auth/isUserLoggedIn',
      currentUser: 'auth/currentUser',
    }),
  },
  methods: {
    ...mapActions({
      logout: 'auth/logOut',
    }),
    signOut() {
      this.logout({ redirect: true, nuke: true })
    },
  },
}
</script>

<template>
  <Layout>
    <v-container>
      <section class="text-center white--text">
        <header>
          <v-icon size="150" color="white">mdi-hammer-wrench</v-icon>

          <h3 class="construction-page__title font-weight-bold display-3 my-10">
            {{ $t('underConstruction.title') }}
          </h3>

          <p class="construction-page__desc text-h6 mt-0">
            {{ $t('underConstruction.description') }}
          </p>
        </header>

        <section
          :class="[
            'd-flex justify-center mt-10',
            isSmallOrLower ? 'flex-column ' : '',
          ]"
        >
          <BaseButton
            v-show="isUserLoggedIn || currentUser"
            id="construction-page__logout-btn"
            x-large
            text
            outlined
            color="white"
            :class="[
              'rounded-lg text-capitalize no-letter-spacing',
              isMobileViewPort ? 'mb-2' : 'mr-2',
            ]"
            @click="signOut"
          >
            <v-icon left class="white--text">mdi-arrow-left</v-icon>
            {{ $t('underConstruction.logoutBtn') }}
          </BaseButton>
          <BaseButton
            id="construction-page__go-home-btn"
            x-large
            light
            color="blue"
            exact
            :class="[
              'rounded-lg text-capitalize no-letter-spacing custom-elevation white--text',
              isMobileViewPort ? '' : 'ml-2',
            ]"
            :to="{ name: routeDefinitions.home.name }"
          >
            {{ $t('underConstruction.returnHomeBtn') }}
          </BaseButton>
        </section>
      </section>
    </v-container>
  </Layout>
</template>
